import Vue from 'vue/dist/vue.min';

export function vm(){
    const v = new Vue({
    el: '#site-header',
		data: {
			flag: false,
		},
    methods: {
      isActive(path) {
        return window.location.pathname.startsWith(path)
      }
    }
    });
};